<template>
  <div>
    <div id="enterprise-information" v-if="enterpriseInfo.base">
      <!-- 基本信息 -->
      <div
        v-if="tabActive.tab2Active == '基本信息'"
        class="enterprise-information-type"
      >
        <div class="enterprise-information-item" id="公司简介">
          <div class="enterprise-information-item-title">公司简介</div>
          <div class="enterprise-information-item-value">
            <div class="text">
              {{ enterpriseInfo.base.description || "" }}
            </div>
          </div>
        </div>
        <div class="enterprise-information-item" id="工商信息">
          <div class="enterprise-information-item-title">工商信息</div>
          <div class="enterprise-information-item-value">
            <enterpriseTableText :table="businessInformation" />
          </div>
        </div>
        <div class="enterprise-information-item" id="股东信息">
          <div class="enterprise-information-item-title">
            股东信息 ({{ shareholderInformation.pageData.totalCount }})
          </div>
          <div class="enterprise-information-item-tag">
            <div
              :class="{
                tag: true,
                'is-active': item.name === tagList.active,
                'is-disabled': item.disabled,
              }"
              v-for="(item, index) in tagList.list"
              :key="index"
              @click="changeTab(item, 3)"
            >
              {{ item.name }}<span>{{ item.count }}</span>
            </div>
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="shareholderInformation"
              @getCompanyList="getCompanyList"
              @handleCurrentChange="handleCurrentChange"
              @addUser="addUser"
            />
          </div>
        </div>
        <div class="enterprise-information-item" id="主要成员">
          <div class="enterprise-information-item-title">
            主要成员 ({{ principleMembers.pageData.totalCount }})
          </div>
          <div class="enterprise-information-item-tag">
            <div
              :class="{
                tag: true,
                'is-active': item.name === tagList.active,
                'is-disabled': item.disabled,
              }"
              v-for="(item, index) in tagList.list"
              :key="index"
              @click="changeTab(item, 3)"
            >
              {{ item.name }} <span>{{ item.count }}</span>
            </div>
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="principleMembers"
              @getCompanyList="getCompanyList"
              @handleCurrentChange="handleCurrentChange"
              @addUser="addUser"
            />
          </div>
        </div>
        <div class="enterprise-information-item" id="对外投资">
          <div class="enterprise-information-item-title">
            对外投资 ({{ investmentAbroad.pageData.totalCount }})
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="investmentAbroad"
              @getCompanyList="getCompanyList"
              @handleCurrentChange="handleCurrentChange"
              @addUser="addUser"
            />
          </div>
        </div>
        <div class="enterprise-information-item" id="分支机构">
          <div class="enterprise-information-item-title">
            分支机构 ({{ branchInformation.pageData.totalCount }})
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="branchInformation"
              @getCompanyList="getCompanyList"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <div class="enterprise-information-item" id="工商变更">
          <div class="enterprise-information-item-title">
            <div>
              工商变更 ({{ businessChangeInformation.pageData.totalCount }})
            </div>
            <div class="enterprise-information-item-title-search">
              <div class="search-item">
                <el-select
                  v-model="businessChangeInformation.searchData.altItemType"
                  placeholder="请选择变更项目"
                  @change="getBusinessChangeInformation"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in businessChangeInformation.searchData
                      .altItemTypeList"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="businessChangeInformation"
              @getCompanyList="getCompanyList"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
      </div>
      <!-- 公司发展 -->
      <div
        v-if="tabActive.tab2Active == '公司发展'"
        class="enterprise-information-type"
      >
        <div class="enterprise-information-item" id="公司项目">
          <div class="enterprise-information-item-title">
            公司项目 ({{ projectList.pageData.totalCount }})
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseCard
              :table="projectList"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
      </div>
      <!-- 企业年报 -->
      <div
        v-if="tabActive.tab2Active == '企业年报'"
        class="enterprise-information-type"
      >
        <div class="enterprise-information-item" id="企业基本信息">
          <div class="enterprise-information-item-title">企业基本信息</div>
          <div class="enterprise-information-item-value">
            <enterpriseTableText :table="companyInfo" />
          </div>
        </div>
        <div class="enterprise-information-item" id="网站或网店信息">
          <div class="enterprise-information-item-title">网站或网店信息</div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="websiteInfo"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <div class="enterprise-information-item" id="股东(发起人)出资信息">
          <div class="enterprise-information-item-title">
            股东(发起人)出资信息
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="subCapitalInfo"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <div class="enterprise-information-item" id="对外投资信息">
          <div class="enterprise-information-item-title">对外投资信息</div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="investmentAbroadInfo"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <div class="enterprise-information-item" id="企业资产状况信息">
          <div class="enterprise-information-item-title">企业资产状况信息</div>
          <div class="enterprise-information-item-value">
            <enterpriseTableText :table="assetsInfo" />
          </div>
        </div>
        <div class="enterprise-information-item">
          <div class="enterprise-information-item-title">社保信息</div>
          <div class="enterprise-information-item-value">
            <enterpriseTableText :table="socialSecurityInfo" />
          </div>
        </div>
      </div>
      <!-- 资质资格 -->
      <div
        v-if="tabActive.tab2Active == '资质资格'"
        class="enterprise-information-type"
      >
        <div class="enterprise-information-item" id="行政许可">
          <div class="enterprise-information-item-title">
            行政许可 ({{ administrativeLicensing.pageData.totalCount }})
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="administrativeLicensing"
              :clientInfo="clientInfo"
              :allFunctionButtons="allFunctionButtons"
              @addQualification="addQualification"
              @deleteQualification="deleteQualification"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <div class="enterprise-information-item" id="资质证书">
          <div class="enterprise-information-item-title">
            资质证书 ({{ qualificationInformation.pageData.totalCount }})
            <!-- <div class="enterprise-information-item-title-search">
            <div class="search-item">
              <el-input
                v-model="qualificationInformation.searchData.keyword"
                placeholder="请输入证书名称/编号"
                @keyup.enter.native="getQualificationInformation"
              >
                <el-button
                  slot="append"
                  icon="el-icon-search"
                  @click.native.stop="getQualificationInformation"
                ></el-button>
              </el-input>
            </div>
            <div class="search-item">
              <el-select
                v-model="qualificationInformation.searchData.licnameStatus"
                placeholder="请选择状态"
                @change="getQualificationInformation"
                clearable
              >
                <el-option
                  v-for="(item, index) in qualificationInformation.searchData
                    .licnameStatusList"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <el-select
                v-model="qualificationInformation.searchData.licnameKind"
                placeholder="请选择类型"
                @change="getQualificationInformation"
                clearable
              >
                <el-option
                  v-for="(item, index) in qualificationInformation.searchData
                    .licnameKindList"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div> -->
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="qualificationInformation"
              :clientInfo="clientInfo"
              :allFunctionButtons="allFunctionButtons"
              @addQualification="addQualification"
              @deleteQualification="deleteQualification"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <div class="enterprise-information-item" id="建筑资质">
          <div class="enterprise-information-item-title">
            建筑资质 ({{ architectureQualification.pageData.totalCount }})
            <!-- <div class="enterprise-information-item-title-search">
            <div class="search-item">
              <el-select
                v-model="architectureQualification.searchData.status"
                placeholder="请选择状态"
                @change="getArchitectureQualification"
                clearable
              >
                <el-option
                  v-for="(item, index) in architectureQualification.searchData
                    .statusCnt"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="search-item">
              <el-select
                v-model="architectureQualification.searchData.type"
                placeholder="请选择类别"
                @change="getArchitectureQualification"
                clearable
              >
                <el-option
                  v-for="(item, index) in architectureQualification.searchData
                    .typeCnt"
                  :key="index"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
          </div> -->
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="architectureQualification"
              :clientInfo="clientInfo"
              :allFunctionButtons="allFunctionButtons"
              @addQualification="addQualification"
              @deleteQualification="deleteQualification"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
      </div>
      <!-- 知识产权 -->
      <div
        v-if="tabActive.tab2Active == '知识产权'"
        class="enterprise-information-type"
      >
        <div class="enterprise-information-item" id="专利信息">
          <div class="enterprise-information-item-title">
            专利信息 ({{ patentInfo.pageData.totalCount }})
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="patentInfo"
              :clientInfo="clientInfo"
              :allFunctionButtons="allFunctionButtons"
              @addQualification="addQualification"
              @linkDialog="linkDialog"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <div class="enterprise-information-item" id="商标信息">
          <div class="enterprise-information-item-title">
            商标信息 ({{ brandInfo.pageData.totalCount }})
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="brandInfo"
              :clientInfo="clientInfo"
              :allFunctionButtons="allFunctionButtons"
              @addQualification="addQualification"
              @linkDialog="linkDialog"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <div class="enterprise-information-item" id="软件著作权">
          <div class="enterprise-information-item-title">
            软件著作权 ({{ softwareCopyrightInfo.pageData.totalCount }})
            <div class="enterprise-information-item-title-search">
              <div class="search-item">
                <el-select
                  v-model="softwareCopyrightInfo.searchData.year"
                  placeholder="请选择登记日期"
                  @change="getSoftwareCopyrightInfo"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in softwareCopyrightInfo.searchData
                      .yearList"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="softwareCopyrightInfo"
              :clientInfo="clientInfo"
              :allFunctionButtons="allFunctionButtons"
              @addQualification="addQualification"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <div class="enterprise-information-item" id="作品著作权">
          <div class="enterprise-information-item-title">
            作品著作权 ({{ workCopyrightInfo.pageData.totalCount }})
            <div class="enterprise-information-item-title-search">
              <div class="search-item">
                <el-select
                  v-model="workCopyrightInfo.searchData.year"
                  placeholder="请选择登记日期"
                  @change="getWorkCopyrightInfo"
                  clearable
                >
                  <el-option
                    v-for="(item, index) in workCopyrightInfo.searchData
                      .yearList"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </div>
            </div>
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="workCopyrightInfo"
              :clientInfo="clientInfo"
              :allFunctionButtons="allFunctionButtons"
              @addQualification="addQualification"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <div class="enterprise-information-item" id="ICP备案">
          <div class="enterprise-information-item-title">
            ICP备案 ({{ IPCInfo.pageData.totalCount }})
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="IPCInfo"
              :clientInfo="clientInfo"
              :allFunctionButtons="allFunctionButtons"
              @addQualification="addQualification"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
        <div class="enterprise-information-item" id="标准信息">
          <div class="enterprise-information-item-title">
            标准信息 ({{ standardInfo.pageData.totalCount }})
          </div>
          <div class="enterprise-information-item-value">
            <enterpriseTable
              :table="standardInfo"
              :clientInfo="clientInfo"
              :allFunctionButtons="allFunctionButtons"
              @addQualification="addQualification"
              @linkDialog="linkDialog"
              @handleCurrentChange="handleCurrentChange"
            />
          </div>
        </div>
      </div>
      <!-- 历史信息 -->
      <div
        v-if="tabActive.tab2Active == '历史信息'"
        class="enterprise-information-type"
      >
        <div class="enterprise-information-item" id="历史工商信息">
          <div class="enterprise-information-item-title">历史工商信息</div>
          <div class="enterprise-information-item-value">
            <enterpriseTableText :table="historyBusinessInformation" />
          </div>
        </div>
        <!-- <div class="enterprise-information-item">
        <div class="enterprise-information-item-title">
          历史股东
        </div>
        <div class="enterprise-information-item-value">
          <enterpriseTable
            :table="qualificationInformation"
            @handleCurrentChange="handleCurrentChange"
          />
        </div>
      </div>
      <div class="enterprise-information-item">
        <div class="enterprise-information-item-title">
          历史高管
        </div>
        <div class="enterprise-information-item-value">
          <enterpriseTable
            :table="qualificationInformation"
            @handleCurrentChange="handleCurrentChange"
          />
        </div>
      </div> -->
      </div>
      <div id="my-dialog" v-if="dialogData.flag">
        <my_dialog
          :width="dialogData.width"
          :title="dialogData.title"
          :buttonArray="dialogData.buttonArray"
          :data="dialogData.data"
          @colseDialog="colseDialog"
          @dialogOper="drawerOper"
          @buttonOper="drawerOper"
          @pageChange="pageChange"
          @changeFlag="changeFlag"
          @selectChange="selectChange"
          @datePickerChange="datePickerChange"
          @handleAvatarSuccess="handleAvatarSuccess"
        ></my_dialog>
      </div>
    </div>
    <div v-else>
      <el-empty description="暂无数据"></el-empty>
    </div>
  </div>
</template>

<script>
import * as allClientData from "@/views/client/js/clientData.js";
import enterpriseTable from "@/components/enterprise-components/enterprise-table";
import enterpriseCard from "@/components/enterprise-components/enterprise-card";
import enterpriseTableText from "@/components/enterprise-components/enterprise-table-text";
import { callWithDelay } from "@/minixs.js";
export default {
  props: {
    clientInfo: {
      type: Object,
      default: () => {},
    },
    tabActive: {
      type: Object,
      default: () => {},
    },
    enterpriseInfo: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    enterpriseTable,
    enterpriseCard,
    enterpriseTableText,
    my_dialog: () => import("@/components/dialog.vue"),
  },
  data() {
    return {
      baseInfo: {},
      dialogData: {
        flag: false,
        width: "45%",
        title: "新建报销",
        buttonArray: [
          {
            text: "提交",
            active: "submit_gnjinjilu",
          },
        ],
        data: [],
      },
      tagList: {},
      // 工商变更
      currentXidInfo: {},
      businessInformation: allClientData.companyInfoByTableText("工商信息"), // 工商信息
      shareholderInformation: {
        type: "shareholderInformation",
        tableData: [],
        tableMenu: [
          {
            label: "股东(发起人)",
            width: "",
            prop: "inv",
            type: "name_and_company",
          },
          {
            label: "持股比例",
            width: "150px",
            prop: "fundedRatioNum",
          },
          {
            label: "认缴出资额",
            width: "200px",
            prop: "subConam",
          },
          {
            label: "实缴出资额",
            width: "200px",
            prop: "acConam",
          },
          {
            label: "认缴出资日期",
            width: "150px",
            prop: "conDate",
          },
        ],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
      }, // 股东信息
      principleMembers: {
        type: "principleMembers",
        tableData: [],
        tableMenu: [
          {
            label: "姓名",
            width: "",
            prop: "name",
            type: "name_and_company",
          },
          {
            label: "职位",
            width: "300px",
            prop: "positionName",
          },
          {
            label: "持股数",
            width: "180px",
            prop: "quantity",
          },
          {
            label: "持股比例",
            width: "180px",
            prop: "fundedRatioStr",
          },
        ],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
      }, // 主要成员
      investmentAbroad: {
        type: "investmentAbroad",
        tableData: [],
        tableMenu: [
          {
            label: "被投资企业名称",
            width: "",
            prop: "name",
            type: "logo_link",
          },
          {
            label: "状态",
            width: "150px",
            prop: "entstatusName",
            type: "entstatusNameStr",
          },
          {
            label: "法定代表人",
            width: "200px",
            prop: "frname",
            type: "name_and_company",
          },
          {
            label: "注册资本",
            width: "150px",
            prop: "regcapStr",
          },
          {
            label: "成立日期",
            width: "130px",
            prop: "esdate",
          },
          {
            label: "持股比例",
            width: "130px",
            prop: "fundedRatioStr",
          },
          {
            label: "认缴出资额度",
            width: "130px",
            prop: "subConam",
          },
        ],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
      }, // 对外投资
      branchInformation: {
        type: "branchInformation",
        tableData: [],
        tableMenu: [
          {
            label: "企业名称",
            width: "",
            prop: "name",
            type: "logo_link",
          },
          {
            label: "状态",
            width: "150px",
            prop: "entstatusName",
            type: "entstatusNameStr",
          },
          {
            label: "法定代表人",
            width: "200px",
            prop: "frname",
            type: "name_and_company",
          },
          {
            label: "成立日期",
            width: "150px",
            prop: "esdate",
          },
          {
            label: "地区",
            width: "180px",
            prop: "area",
          },
        ],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
      }, // 分支机构
      businessChangeInformation: {
        type: "businessChangeInformation",
        searchData: {
          altItemType: "",
          altItemTypeList: [],
        },
        tableData: [],
        tableMenu: [
          {
            label: "变更日期",
            width: "200px",
            prop: "altdate",
          },
          {
            label: "变更项目",
            width: "200px",
            prop: "altItemType",
          },
          {
            label: "变更前",
            prop: "altbe",
          },
          {
            label: "变更后",
            prop: "altaf",
          },
        ],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
      }, // 工商变更
      projectList: {
        type: "projectList",
        tableData: [],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
      }, // 项目列表
      companyInfo: allClientData.companyInfoByTableText("企业基本信息"),
      assetsInfo: allClientData.companyInfoByTableText("企业资产状况信息"),
      annualReportInfo: {}, // 企业年报
      websiteInfo: {
        type: "websiteInfo",
        tableData: [],
        tableMenu: [
          {
            label: "类型",
            width: "",
            prop: "webtype",
          },
          {
            label: "名称",
            width: "",
            prop: "websitname",
          },
          {
            label: "网址",
            width: "",
            prop: "website",
            type: "link",
          },
        ],
      }, // 网站或网店信息
      subCapitalInfo: {
        tableData: [],
        tableMenu: [
          {
            label: "发起人",
            width: "",
            prop: "inv",
          },
          {
            label: "认缴出资额",
            width: "200px",
            prop: "lisubconam",
          },
          {
            label: "认缴出资时间",
            width: "120px",
            prop: "subcondate",
          },
          {
            label: "认缴出资方式",
            width: "120px",
            prop: "subconformCn",
          },
          {
            label: "实缴出资额",
            width: "200px",
            prop: "liacconam",
          },
          {
            label: "实缴出资时间",
            width: "120px",
            prop: "accondate",
          },
          {
            label: "实缴出资方式",
            width: "120px",
            prop: "acconformCn",
          },
        ],
      }, // 股东(发起人)出资信息
      investmentAbroadInfo: {
        type: "investmentAbroadInfo",
        tableData: [],
        tableMenu: [
          {
            label: "对外投资企业名称",
            width: "",
            prop: "invName",
            type: "logo_link",
          },
          {
            label: "统一社会信用代码",
            width: "",
            prop: "creditCode",
          },
        ],
      }, // 对外投资信息
      socialSecurityInfo: allClientData.companyInfoByTableText("社保信息"),
      administrativeLicensing: {
        type: "administrativeLicensing",
        tableData: [],
        tableMenu: [
          // {
          //   label: "序号",
          //   width: "",
          //   prop: "altdate",
          // },
          {
            label: "行政许可编号",
            width: "",
            prop: "licno",
          },
          {
            label: "许可文件名称",
            prop: "licname",
          },
          {
            label: "有效期自",
            prop: "valform",
            width: "120px",
          },
          {
            label: "有效期至",
            prop: "valto",
            width: "120px",
          },
          {
            label: "许可机关",
            prop: "licanth",
            width: "",
          },
          {
            label: "许可内容",
            prop: "licensecontent",
            width: "",
          },
          {
            label: "资质来源",
            prop: "dataSourceStateName",
            width: "",
          },
        ],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
        buttonInfo: {
          width: "210px",
          add: {
            icon: "el-icon-circle-plus-outline",
            active: "add_qualification",
            authority: "addQualification",
          },
          list: [
            {
              text: "添加到客户资质",
              active: "add_qualification",
              type: "primary",
              size: "mini",
              authority: "addQualification",
            },
            {
              text: "删除",
              active: "delete_qualification",
              type: "danger",
              size: "mini",
              authority: "deleteQualification",
            },
          ],
        },
      }, // 行政许可
      qualificationInformation: {
        type: "qualificationInformation",
        searchData: {
          keyword: "", // 关键字
          licnameKind: "", // 分类；空为全部
          licnameStatus: "", // 状态；空为全部
          licnameKindList: [],
          licnameStatusList: [],
        },
        tableData: [],
        tableMenu: [
          {
            label: "证书名称",
            prop: "licname",
            width: "",
          },
          {
            label: "证书编号",
            prop: "licno",
          },
          {
            label: "发证机构",
            prop: "licanth",
          },
          {
            label: "有效期自",
            prop: "valform",
            width: "120px",
          },
          {
            label: "截止日期",
            prop: "valto",
            width: "120px",
          },
          {
            label: "证书状态",
            prop: "licnameStatus",
          },
          {
            label: "证书类型",
            prop: "licnameKind",
          },
          {
            label: "资质来源",
            prop: "dataSourceStateName",
            width: "",
          },
        ],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
        buttonInfo: {
          width: "210px",
          add: {
            icon: "el-icon-circle-plus-outline",
            active: "add_qualification",
            authority: "addQualification",
          },
          list: [
            {
              text: "添加到客户资质",
              active: "add_qualification",
              // icon: "el-icon-folder-add",
              type: "primary",
              size: "mini",
              authority: "addQualification",
            },
            {
              text: "删除",
              active: "delete_qualification",
              type: "danger",
              size: "mini",
              authority: "deleteQualification",
            },
          ],
        },
      }, // 资质证书
      architectureQualification: {
        type: "architectureQualification",
        searchData: {
          type: "", // 类型；空为全部
          status: "", // 状态；空为全部
          statusCnt: [],
          typeCnt: [],
        },
        tableData: [],
        tableMenu: [
          {
            label: "资质类别",
            prop: "type",
            width: "",
          },
          {
            label: "资质证书号",
            prop: "registerNo",
          },
          {
            label: "资质名称及等级",
            prop: "name",
          },
          {
            label: "发证日期",
            prop: "validStart",
            width: "120px",
          },
          {
            label: "证书有效期",
            prop: "validEnd",
            width: "120px",
          },
          {
            label: "发证机关",
            prop: "issueOrg",
          },
          {
            label: "资质范围",
            prop: "scope",
          },
          {
            label: "资质来源",
            prop: "dataSourceStateName",
            width: "",
          },
        ],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
        buttonInfo: {
          width: "210px",
          add: {
            icon: "el-icon-circle-plus-outline",
            active: "add_qualification",
            authority: "addQualification",
          },
          list: [
            {
              text: "添加到客户资质",
              active: "add_qualification",
              // icon: "el-icon-folder-add",
              type: "primary",
              size: "mini",
              authority: "addQualification",
            },
            {
              text: "删除",
              active: "delete_qualification",
              type: "danger",
              size: "mini",
              authority: "deleteQualification",
            },
          ],
        },
      }, // 建筑资质
      qualificationData: null,
      qualificationTypeList: [], // 资质类型
      patentInfo: {
        type: "patentInfo",
        tableData: [],
        tableMenu: [
          {
            label: "专利名称",
            prop: "patentName",
            width: "",
            type: "link_dialog",
          },
          {
            label: "专利类型",
            prop: "patentCategory",
          },
          {
            label: "公告/公布号",
            prop: "outhorNum",
          },
          {
            label: "公告/公布日期",
            prop: "pubTime",
            width: "120px",
          },
          {
            label: "申请号",
            prop: "licenseCode",
          },
          {
            label: "申请日期",
            prop: "requestDate",
            width: "120px",
          },
          {
            label: "法律状态",
            prop: "stateMeaning",
          },
          {
            label: "法律状态公告日",
            prop: "",
          },
          {
            label: "待缴费用",
            prop: "",
          },
        ],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
        buttonInfo: {
          width: "210px",
          list: [
            {
              text: "添加到客户资质",
              active: "add_qualification",
              // icon: "el-icon-folder-add",
              type: "primary",
              size: "mini",
              authority: "addQualification",
            },
            {
              text: "删除",
              active: "delete_qualification",
              type: "danger",
              size: "mini",
              authority: "deleteQualification",
            },
          ],
        },
      }, // 专利信息
      brandInfo: {
        type: "brandInfo",
        tableData: [],
        tableMenu: [
          {
            label: "商标",
            prop: "logoUrl",
            width: "80px",
            type: "img",
          },
          {
            label: "商标名称",
            prop: "name",
            type: "link_dialog",
          },
          {
            label: "申请日期",
            prop: "requestDate",
          },
          {
            label: "注册号",
            prop: "number",
          },
          {
            label: "注册公告日期",
            prop: "",
          },
          {
            label: "商标类别",
            prop: "type",
          },
          {
            label: "状态",
            prop: "status",
            width: "120px",
          },
        ],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
        buttonInfo: {
          width: "210px",
          list: [
            {
              text: "添加到客户资质",
              active: "add_qualification",
              // icon: "el-icon-folder-add",
              type: "primary",
              size: "mini",
              authority: "addQualification",
            },
            {
              text: "删除",
              active: "delete_qualification",
              type: "danger",
              size: "mini",
              authority: "deleteQualification",
            },
          ],
        },
      }, // 商标信息
      softwareCopyrightInfo: {
        type: "softwareCopyrightInfo",
        searchData: {
          year: "",
          yearList: [],
        },
        tableData: [],
        tableMenu: [
          {
            label: "软件名称",
            prop: "crName",
          },
          {
            label: "软件简称",
            prop: "crShortname",
          },
          {
            label: "版本号",
            prop: "crBatchnum",
            width: "100px",
          },
          {
            label: "首次发表日期",
            prop: "crFirstdate",
            width: "120px",
          },
          {
            label: "登记号",
            prop: "crRegno",
          },
          {
            label: "登记日期",
            prop: "crRegdate",
            width: "120px",
          },
          {
            label: "软件著作分类",
            prop: "crSoftwaretype",
          },
          {
            label: "行业分类",
            prop: "crTypecode",
          },
        ],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
        buttonInfo: {
          width: "210px",
          list: [
            {
              text: "添加到客户资质",
              active: "add_qualification",
              // icon: "el-icon-folder-add",
              type: "primary",
              size: "mini",
              authority: "addQualification",
            },
            {
              text: "删除",
              active: "delete_qualification",
              type: "danger",
              size: "mini",
              authority: "deleteQualification",
            },
          ],
        },
      }, // 软件著作权
      workCopyrightInfo: {
        type: "workCopyrightInfo",
        searchData: {
          year: "",
          yearList: [],
        },
        tableData: [],
        tableMenu: [
          {
            label: "作品名称",
            prop: "wrName",
          },
          {
            label: "创作完成时间",
            prop: "wrCompletiondate",
          },
          {
            label: "首次发表日期",
            prop: "wrPublicationdate",
          },
          {
            label: "登记号",
            prop: "wrRegistrationno",
          },

          {
            label: "登记日期",
            prop: "wrRegistrationdate",
          },
          {
            label: "作品类别",
            prop: "wrType",
          },
        ],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
        buttonInfo: {
          width: "210px",
          list: [
            {
              text: "添加到客户资质",
              active: "add_qualification",
              // icon: "el-icon-folder-add",
              type: "primary",
              size: "mini",
              authority: "addQualification",
            },
            {
              text: "删除",
              active: "delete_qualification",
              type: "danger",
              size: "mini",
              authority: "deleteQualification",
            },
          ],
        },
      }, // 作品著作权
      IPCInfo: {
        type: "IPCInfo",
        tableData: [],
        tableMenu: [
          {
            label: "网址",
            prop: "openUrl",
          },
          {
            label: "域名",
            prop: "domain",
          },
          {
            label: "网站名称",
            prop: "name",
          },
          {
            label: "网站备案/许可证号",
            prop: "icp",
          },
          {
            label: "审核日期",
            prop: "auditDate",
            width: "150px",
          },
        ],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
        buttonInfo: {
          width: "210px",
          list: [
            {
              text: "添加到客户资质",
              active: "add_qualification",
              // icon: "el-icon-folder-add",
              type: "primary",
              size: "mini",
              authority: "addQualification",
            },
            {
              text: "删除",
              active: "delete_qualification",
              type: "danger",
              size: "mini",
              authority: "deleteQualification",
            },
          ],
        },
      }, // ICP备案
      standardInfo: {
        type: "standardInfo",
        tableData: [],
        tableMenu: [
          {
            label: "标准名称",
            prop: "name",
            width: "200px",
            type: "link_dialog",
          },
          {
            label: "标准编号",
            prop: "standardNo",
          },
          {
            label: "标准级别",
            prop: "standardCategory",
          },
          {
            label: "起草单位",
            prop: "draftUnitsByTrans",
            type: "list",
          },
          {
            label: "发布/批准日期",
            prop: "establishedAt",
          },
          {
            label: "实施日期",
            prop: "executedFrom",
          },
        ],
        pageData: {
          pageIndex: 1,
          pageSize: 10,
          totalCount: 0,
        },
        buttonInfo: {
          width: "210px",
          list: [
            {
              text: "添加到客户资质",
              active: "add_qualification",
              // icon: "el-icon-folder-add",
              type: "primary",
              size: "mini",
              authority: "addQualification",
            },
            {
              text: "删除",
              active: "delete_qualification",
              type: "danger",
              size: "mini",
              authority: "deleteQualification",
            },
          ],
        },
      }, // 标准信息
      historyBusinessInformation:
        allClientData.companyInfoByTableText("历史工商信息"), // 历史工商信息
      allFunctionButtons: this.$featureData.getAllFunctionButtons("clientInfo"),
    };
  },
  mixins: [callWithDelay],
  watch: {
    "tabActive.tab2Active": {
      handler(newValue, oldValue) {
        if (this.enterpriseInfo.base && this.enterpriseInfo.base.eid) {
          this.changeTab();
        }
      },
    },
    "tabActive.tab3Active": {
      handler(newValue, oldValue) {
        if (this.tabActive.tab2Active == "企业年报") {
          this.annualReport();
        } else {
          // tabActive.tab3Active 变化时 页面滑动到对应区域
          this.$nextTick(() => {
            const targetElement = document.getElementById(newValue);
            if (targetElement) {
              targetElement.scrollIntoView({ behavior: "smooth" });
            }
          });
        }
      },
    },
  },
  methods: {
    getModelFeatureAuthority() {
      console.log("获取权限");
      this.$authority.getModelFeatureAuthority(
        this,
        "clientInfo",
        this.allFunctionButtons,
        (data) => {
          this.allFunctionButtons = data;
          console.log("当前显示的按钮权限", data);
        },
      );
    },
    getBusinessInformation() {
      this.businessInformation =
        allClientData.companyInfoByTableText("工商信息");
      this.businessInformation.forEach((item) => {
        if (item.label == "经营期限") {
          // 经营期限
          item.value = this.enterpriseInfo.base
            ? this.enterpriseInfo.base.opfrom +
              "--" +
              this.enterpriseInfo.base.opto
            : "";
        } else if (item.label == "国标行业") {
          item.value = this.enterpriseInfo.base
            ? this.enterpriseInfo.base.industryphyNameStr
            : "";
        } else {
          item.value = this.enterpriseInfo.base
            ? this.enterpriseInfo.base[item.key]
            : "";
        }
      });
    },
    // 获取股东信息
    getShareholderInformation() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.shareholderInformation.pageData.pageIndex,
        pageSize: this.shareholderInformation.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_1041",
        requestData,
        (data) => {
          // 获取股东 xid
          let xids = data.entInfo.pagerShareholders.data.map(
            (item) => item.xid,
          );
          this.shareholderInformation.tableData =
            data.entInfo.pagerShareholders.data;
          this.shareholderInformation.tableData.forEach((item) => {
            // 处理成员信息
            xids.forEach((xid) => {
              if (xid == item.xid) {
                item.xidInfo = data.entInfo.personStatistics[xid];
              }
            });
            // 处理持股比例
            if (item.fundedRatioNum) {
              item.fundedRatioNum =
                (item.fundedRatioNum * 100).toFixed(2) + "%";
            }
            // 认缴出资额
            if (item.subConam) {
              item.subConam = item.subConam + "万";
            }
            // 实缴出资额
            if (item.acConam) {
              item.acConam = item.acConam + "万";
            }
          });
          this.shareholderInformation.pageData = {
            pageIndex: data.entInfo.pagerShareholders.pageIndex,
            pageSize: data.entInfo.pagerShareholders.pageSize,
            totalCount: data.entInfo.pagerShareholders.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "基本信息",
            tab3Active: "股东信息",
            count: this.shareholderInformation.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 获取主要成员
    getPrincipleMembers() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.principleMembers.pageData.pageIndex,
        pageSize: this.principleMembers.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_1101",
        requestData,
        (data) => {
          // 获取股东 xid
          let xids = data.entInfo.pagerPriPersons.data.map((item) => item.pid);
          this.principleMembers.tableData = data.entInfo.pagerPriPersons.data;
          this.principleMembers.tableData.forEach((item) => {
            // 处理成员信息
            xids.forEach((xid) => {
              if (xid == item.pid) {
                item.xidInfo = data.entInfo.personStatistics[xid];
              }
            });
          });
          this.principleMembers.pageData = {
            pageIndex: data.entInfo.pagerPriPersons.pageIndex,
            pageSize: data.entInfo.pagerPriPersons.pageSize,
            totalCount: data.entInfo.pagerPriPersons.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "基本信息",
            tab3Active: "主要成员",
            count: this.principleMembers.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 获取对外投资
    getInvestmentAbroad() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.investmentAbroad.pageData.pageIndex,
        pageSize: this.investmentAbroad.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_1061",
        requestData,
        (data) => {
          // 获取股东 xid
          let xids = data.entInfo.pagerInvestments.data.map(
            (item) => item.frpid,
          );
          this.investmentAbroad.tableData = data.entInfo.pagerInvestments.data;
          this.investmentAbroad.tableData.forEach((item) => {
            // 处理成员信息
            xids.forEach((xid) => {
              if (xid == item.frpid) {
                item.xidInfo = data.entInfo.personStatistics[xid];
              }
            });
            item.entstatusNameStr = allClientData.companyStatus(
              item.entstatusName,
            );
          });
          this.investmentAbroad.pageData = {
            pageIndex: data.entInfo.pagerInvestments.pageIndex,
            pageSize: data.entInfo.pagerInvestments.pageSize,
            totalCount: data.entInfo.pagerInvestments.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "基本信息",
            tab3Active: "对外投资",
            count: this.investmentAbroad.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 获取分支机构
    getBranchInformation() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.branchInformation.pageData.pageIndex,
        pageSize: this.branchInformation.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_1021",
        requestData,
        (data) => {
          // 获取股东 xid
          let xids = data.entInfo.pagerBranches.data.map((item) => item.frpid);
          this.branchInformation.tableData = data.entInfo.pagerBranches.data;
          this.branchInformation.tableData.forEach((item) => {
            // 处理成员信息
            xids.forEach((xid) => {
              if (xid == item.frpid) {
                item.xidInfo = data.entInfo.personStatistics[xid];
              }
            });
            item.area = `${item.regorgProvince}-${item.regorgCity}-${item.regorgCounty}`;
            item.entstatusNameStr = allClientData.companyStatus(
              item.entstatusName,
            );
          });
          this.branchInformation.pageData = {
            pageIndex: data.entInfo.pagerBranches.pageIndex,
            pageSize: data.entInfo.pagerBranches.pageSize,
            totalCount: data.entInfo.pagerBranches.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "基本信息",
            tab3Active: "分支机构",
            count: this.branchInformation.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 获取工商变更
    getBusinessChangeInformation() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.businessChangeInformation.pageData.pageIndex,
        pageSize: this.businessChangeInformation.pageData.pageSize,
        altItemType: this.businessChangeInformation.searchData.altItemType,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_1031",
        requestData,
        (data) => {
          this.businessChangeInformation.tableData =
            data.entInfo.pagerAlterRecord.data;
          this.businessChangeInformation.searchData.altItemTypeList =
            data.entInfo.pagerAlterRecord.extData.alterTypeCount;

          this.businessChangeInformation.pageData = {
            pageIndex: data.entInfo.pagerAlterRecord.pageIndex,
            pageSize: data.entInfo.pagerAlterRecord.pageSize,
            totalCount: data.entInfo.pagerAlterRecord.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "基本信息",
            tab3Active: "工商变更",
            count: this.businessChangeInformation.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 查询关联公司
    getCompanyList(data, pageData) {
      this.currentXidInfo = data;
      let name = this.currentXidInfo.name;
      let pid = this.currentXidInfo.pid;

      this.dialogData.width = "800px";
      this.dialogData.title = name + "关联公司";
      this.dialogData.buttonArray = [];

      let requestData = {
        pid: pid,
        pageIndex: pageData ? pageData.pageIndex : 1,
        pageSize: pageData ? pageData.pageSize : 10,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_4590",
        requestData,
        (data) => {
          data.personInfo.relationCompanies.data.forEach((item) => {
            // 处理省市县
            item.areaList = `${item.regorgProvince}-${item.regorgCity}-${item.regorgCounty}`;
            // 处理注册资本
            item.regcapStr = item.regcap + "万";
            // 处理经营状态
            item.companyStatusNameStr = allClientData.companyStatus(
              item.companyStatusName,
            );
            // 处理持股比例
            item.fundedRatioNumStr = this.NumberToPercentage(
              item.fundedRatioNum,
            );
          });
          this.dialogData.data = [
            {
              type: "table-enterprise",
              title: "",
              data: {
                type: "companyList",
                tableMenu: allClientData.enterpriseByCompanyList(),
                tableData: data.personInfo.relationCompanies.data,
                pageData: {
                  pageIndex: data.personInfo.relationCompanies.pageIndex, // 当前页数
                  totalCount: data.personInfo.relationCompanies.totalCount, // 总条目数
                  pageSize: data.personInfo.relationCompanies.pageSize, // 每页条数
                },
              },
              value: "",
            },
          ];
          this.dialogData.flag = true;
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 行政许可
    getAdministrativeLicensing() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid, // 企业id  必传
        pageNumber: this.administrativeLicensing.pageData.pageIndex,
        pageSize: this.administrativeLicensing.pageData.pageSize,
        orders: [
          {
            field: "xeal.gmt_create",
            direction: "DESC", // 属性值 DESC：倒叙  ASC：升序
          },
        ],
      };
      this.$request(
        "post",
        "/xlbEntAdmLic/page",
        requestData,
        (data) => {
          // 获取股东 xid
          this.administrativeLicensing.tableData = data.list;
          this.transTabelData(this.administrativeLicensing.tableData);
          if (data.total > 0) {
            this.administrativeLicensing.pageData.totalCount = data.total;
            this.$emit("changeActiveCount", {
              tab2Active: "资质资格",
              tab3Active: "行政许可",
              count: this.administrativeLicensing.pageData.totalCount,
            });
          }
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 资质证书
    getQualificationInformation() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid, // 企业id  必传
        keyword: this.qualificationInformation.searchData.keyword, // 搜索关键字
        licnameKind: this.qualificationInformation.searchData.licnameKind, // 分类；空为全部
        licnameStatus: this.qualificationInformation.searchData.licnameStatus, // 状态；空为全部
        pageNumber: this.qualificationInformation.pageData.pageIndex,
        pageSize: this.qualificationInformation.pageData.pageSize,
        orders: [
          {
            field: "xeal.gmt_create",
            direction: "DESC", // 属性值 DESC：倒叙  ASC：升序
          },
        ],
      };
      this.$request(
        "post",
        "/xlbCertificate/page",
        requestData,
        (data) => {
          // 获取股东 xid
          this.qualificationInformation.tableData = data.list;
          this.transTabelData(this.qualificationInformation.tableData);
          // 获取筛选项数据
          // this.qualificationInformation.searchData.licnameKindList =
          //   data.entInfo.entZzzs.extData.licnameKindList;
          // this.qualificationInformation.searchData.licnameStatusList =
          //   data.entInfo.entZzzs.extData.licnameStatusList;

          this.qualificationInformation.pageData.totalCount = data.total;
          this.$emit("changeActiveCount", {
            tab2Active: "资质资格",
            tab3Active: "资质证书",
            count: this.qualificationInformation.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 建筑资质
    getArchitectureQualification() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        // type: this.architectureQualification.searchData.type, // 类型；空为全部,
        // status: this.architectureQualification.searchData.status, // 状态；空为全部,
        pageNumber: this.architectureQualification.pageData.pageIndex,
        pageSize: this.architectureQualification.pageData.pageSize,
        orders: [
          {
            field: "xeal.gmt_create",
            direction: "DESC", // 属性值 DESC：倒叙  ASC：升序
          },
        ],
      };
      this.$request(
        "post",
        "/xlbBuildQualification/page",
        requestData,
        (data) => {
          // 获取股东 xid
          this.architectureQualification.tableData = data.list;
          this.transTabelData(this.architectureQualification.tableData);
          // 获取筛选项数据
          this.architectureQualification.totalCount = data.total;
          this.$emit("changeActiveCount", {
            tab2Active: "资质资格",
            tab3Active: "建筑资质",
            count: this.architectureQualification.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 企业项目列表
    getProjectList() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.projectList.pageData.pageIndex,
        pageSize: this.projectList.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_1591",
        requestData,
        (data) => {
          this.projectList.tableData = data.entInfo.pagerProjects.data;
          this.projectList.pageData = {
            pageIndex: data.entInfo.pagerProjects.pageIndex,
            pageSize: data.entInfo.pagerProjects.pageSize,
            totalCount: data.entInfo.pagerProjects.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "公司发展",
            tab3Active: "公司项目",
            count: this.projectList.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 年报年度列表
    entAnYears() {
      this.$request(
        "get",
        `/xiaoLanBen/api_4752?eid=${this.enterpriseInfo.base.eid}`,
        {},
        (data) => {
          let result = data.entInfo.entAnYears;
          this.$emit("entAnYears", result);
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 年报信息(指定年份)
    annualReport() {
      // 去除字符串最后两位字符 年份
      this.annualReportInfo = {};
      this.websiteInfo.tableData = [];
      this.subCapitalInfo.tableData = [];
      this.investmentAbroadInfo.tableData = [];
      this.companyInfo = allClientData.companyInfoByTableText("企业基本信息");
      this.assetsInfo =
        allClientData.companyInfoByTableText("企业资产状况信息");
      this.socialSecurityInfo =
        allClientData.companyInfoByTableText("社保信息");

      let year = this.tabActive.tab3Active.slice(0, -2);
      this.$request(
        "get",
        `/xiaoLanBen/api_1660?eid=${this.enterpriseInfo.base.eid}&year=${year}`,
        {},
        (data) => {
          if (data.entInfo.entAnInfo) {
            this.annualReportInfo = data.entInfo.entAnInfo;
            console.log("this.annualReportInfo", this.annualReportInfo);
            if (this.annualReportInfo.anInfo) {
              // 处理企业基本信息
              this.companyInfo.forEach((item) => {
                if (item.key === "empnum") {
                  item.value =
                    this.annualReportInfo.anInfo[item.key] || "企业选择不公开";
                } else {
                  item.value = this.annualReportInfo.anInfo[item.key];
                }
              });
              // 处理企业资产状况信息
              this.assetsInfo.forEach((item) => {
                item.value = this.annualReportInfo.anInfo[item.key];
              });
            }
            // 处理网站或网店信息
            if (this.annualReportInfo.website) {
              this.websiteInfo.tableData = this.annualReportInfo.website;
            }
            // 处理股东(发起人)出资信息
            if (this.annualReportInfo.subCapital) {
              this.subCapitalInfo.tableData = this.annualReportInfo.subCapital;
            }
            // 处理对外投资信息
            if (this.annualReportInfo.subCapital) {
              this.investmentAbroadInfo.tableData =
                this.annualReportInfo.forInvestment;
            }

            // 处理社保信息
            this.socialSecurityInfo.forEach((item) => {
              item.value = this.annualReportInfo.socsecInfo
                ? this.annualReportInfo.socsecInfo[item.key]
                : "--";
              if (item.type == "list") {
                item.list.forEach((ele) => {
                  if (this.annualReportInfo.socsecInfo) {
                    ele.value =
                      this.annualReportInfo.socsecInfo[ele.key] ||
                      "企业选择不公示";
                  } else {
                    ele.value = "企业选择不公示";
                  }
                });
              }
            });
          }
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 专利信息
    getPatentInfo() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.patentInfo.pageData.pageIndex,
        pageSize: this.patentInfo.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_3021",
        requestData,
        (data) => {
          this.patentInfo.tableData = data.entInfo.pagerParent.data;

          this.patentInfo.pageData = {
            pageIndex: data.entInfo.pagerParent.pageIndex,
            pageSize: data.entInfo.pagerParent.pageSize,
            totalCount: data.entInfo.pagerParent.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "知识产权",
            tab3Active: "专利信息",
            count: this.patentInfo.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 商标信息
    getBrandInfo() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.brandInfo.pageData.pageIndex,
        pageSize: this.brandInfo.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_3001",
        requestData,
        (data) => {
          this.brandInfo.tableData = data.entInfo.pagerTrademarks.data;
          this.brandInfo.tableData.forEach((item) => {
            item.type = item.typeCodes + "类 " + item.types;
          });
          this.brandInfo.pageData = {
            pageIndex: data.entInfo.pagerTrademarks.pageIndex,
            pageSize: data.entInfo.pagerTrademarks.pageSize,
            totalCount: data.entInfo.pagerTrademarks.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "知识产权",
            tab3Active: "商标信息",
            count: this.brandInfo.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 软件著作权
    getSoftwareCopyrightInfo() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        year: this.softwareCopyrightInfo.searchData.year, // 年度；空为全部
        pageIndex: this.softwareCopyrightInfo.pageData.pageIndex,
        pageSize: this.softwareCopyrightInfo.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_3041",
        requestData,
        (data) => {
          this.softwareCopyrightInfo.tableData =
            data.entInfo.pagerSoftwareCopyright.data;

          this.softwareCopyrightInfo.searchData.yearList =
            data.entInfo.pagerSoftwareCopyright.extData.years;

          this.softwareCopyrightInfo.pageData = {
            pageIndex: data.entInfo.pagerSoftwareCopyright.pageIndex,
            pageSize: data.entInfo.pagerSoftwareCopyright.pageSize,
            totalCount: data.entInfo.pagerSoftwareCopyright.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "知识产权",
            tab3Active: "软件著作权",
            count: this.softwareCopyrightInfo.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 作品著作权
    getWorkCopyrightInfo() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        year: this.workCopyrightInfo.searchData.year, // 年度；空为全部
        pageIndex: this.workCopyrightInfo.pageData.pageIndex,
        pageSize: this.workCopyrightInfo.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_3061",
        requestData,
        (data) => {
          this.workCopyrightInfo.tableData =
            data.entInfo.pagerWorkCopyright.data;

          this.workCopyrightInfo.searchData.yearList =
            data.entInfo.pagerWorkCopyright.extData.years;

          this.workCopyrightInfo.pageData = {
            pageIndex: data.entInfo.pagerWorkCopyright.pageIndex,
            pageSize: data.entInfo.pagerWorkCopyright.pageSize,
            totalCount: data.entInfo.pagerWorkCopyright.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "知识产权",
            tab3Active: "作品著作权",
            count: this.workCopyrightInfo.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // ICP备案
    getIPCInfo() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.IPCInfo.pageData.pageIndex,
        pageSize: this.IPCInfo.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_3031",
        requestData,
        (data) => {
          this.IPCInfo.tableData = data.entInfo.pagerWebSites.data;

          this.IPCInfo.pageData = {
            pageIndex: data.entInfo.pagerWebSites.pageIndex,
            pageSize: data.entInfo.pagerWebSites.pageSize,
            totalCount: data.entInfo.pagerWebSites.totalCount,
          };
          this.$emit("changeActiveCount", {
            tab2Active: "知识产权",
            tab3Active: "ICP备案",
            count: this.IPCInfo.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 标准信息
    getStandardInfo() {
      let requestData = {
        eid: this.enterpriseInfo.base.eid,
        pageIndex: this.standardInfo.pageData.pageIndex,
        pageSize: this.standardInfo.pageData.pageSize,
      };
      this.$request(
        "post",
        "/xiaoLanBen/api_4755",
        requestData,
        (data) => {
          this.standardInfo.tableData = data.entInfo.pagerSacStd.data;
          this.standardInfo.tableData.forEach((item) => {
            if (item.draftUnits && item.draftUnits.length > 2) {
              item.draftUnitsByTrans = item.draftUnits.slice(0, 2);
              item.draftUnitsByTrans.push({
                eid: "",
                name: "...",
              });
            } else {
              item.draftUnitsByTrans = item.draftUnits;
            }
          });
          if (data.entInfo.pagerSacStd.totalCount > 0) {
            this.standardInfo.pageData = {
              pageIndex: data.entInfo.pagerSacStd.pageIndex,
              pageSize: data.entInfo.pagerSacStd.pageSize,
              totalCount: data.entInfo.pagerSacStd.totalCount,
            };
          }
          this.$emit("changeActiveCount", {
            tab2Active: "知识产权",
            tab3Active: "标准信息",
            count: this.standardInfo.pageData.totalCount,
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    // 历史工商信息
    getHistoryBusinessInformation() {
      this.$request(
        "get",
        "/xiaoLanBen/api_1111?eid=" + this.enterpriseInfo.base.eid,
        {},
        (data) => {
          this.historyBusinessInformation.forEach((item) => {
            if (data[item.key] && data[item.key].length > 0) {
              item.list = data[item.key].map((it) => {
                return {
                  label: it.altDate,
                  value: it.altBe,
                  key: item.key,
                  labelSpan: 6,
                  valueSpan: 18,
                };
              });
            }
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    transTabelData(tableData) {
      return tableData.forEach((item) => {
        switch (item.dataSourceState) {
          case 0:
            item.dataSourceStateName = "手动添加";
            break;
          case 1:
            item.dataSourceStateName = "小蓝本同步";
            break;
          default:
            break;
        }
      });
    },
    /**
     * 选择页码事件
     * val:当前页
     */
    handleCurrentChange(table) {
      // 首字母转大写
      // const TYPE = table.type.substr(0, 1).toUpperCase() + table.type.substr(1);
      // this[table.type].pageData = table.pageData;
      // this["get" + TYPE]();
      switch (table.type) {
        case "shareholderInformation":
          // 股东信息
          this.shareholderInformation.pageData = table.pageData;
          this.getShareholderInformation();
          break;
        case "principleMembers":
          // 主要成员
          this.principleMembers.pageData = table.pageData;
          this.getPrincipleMembers();
          break;
        case "investmentAbroad":
          // 对外投资
          this.investmentAbroad.pageData = table.pageData;
          this.getInvestmentAbroad();
          break;
        case "branchInformation":
          // 分支机构
          this.branchInformation.pageData = table.pageData;
          this.getBranchInformation();
          break;
        case "businessChangeInformation":
          // 工商变更
          this.businessChangeInformation.pageData = table.pageData;
          this.getBusinessChangeInformation();
          break;
        case "administrativeLicensing":
          // 行政许可
          this.administrativeLicensing.pageData = table.pageData;
          this.getAdministrativeLicensing();
          break;
        case "qualificationInformation":
          // 资质证书
          this.qualificationInformation.pageData = table.pageData;
          this.getQualificationInformation();
          break;
        case "architectureQualification":
          // 建筑资质
          this.architectureQualification.pageData = table.pageData;
          this.getArchitectureQualification();
          break;
        case "patentInfo":
          // 专利信息
          this.patentInfo.pageData = table.pageData;
          this.getPatentInfo();
          break;
        case "brandInfo":
          // 专利信息
          this.brandInfo.pageData = table.pageData;
          this.getBrandInfo();
          break;
        case "softwareCopyrightInfo":
          // 软件著作权
          this.softwareCopyrightInfo.pageData = table.pageData;
          this.getSoftwareCopyrightInfo();
          break;
        case "workCopyrightInfo":
          // 作品著作权
          this.workCopyrightInfo.pageData = table.pageData;
          this.getWorkCopyrightInfo();
          break;
        case "IPCInfo":
          // ICP备案
          this.IPCInfo.pageData = table.pageData;
          this.getIPCInfo();
          break;
        case "standardInfo":
          // 标准信息
          this.standardInfo.pageData = table.pageData;
          this.getStandardInfo();
          break;
        case "projectList":
          // 公司项目
          this.projectList.pageData = table.pageData;
          this.getProjectList();
          break;
        default:
          break;
      }
    },
    drawerOper(active) {
      let requestData = {};
      let flag = false;
      switch (active) {
        case "sure_add_user":
          // 确认添加老板资料
          this.dialogData.data.forEach((item) => {
            requestData[item.key] = item.value;
          });
          this.$request(
            "post",
            "/bossInfo/add",
            requestData,
            (data) => {
              this.$message.success("添加成功!");
              this.dialogData.flag = false;
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          break;
        case "makesure_create_qualification":
          // 确认添加资质
          requestData = {
            id: "", // 有则修改,空则添加
            companyId: this.baseInfo.company.companyId, // 公司id
            clientId: this.clientInfo.id, // 客户id
            number: this.dialogData.data[0].value || "", // 资质编号
            name: this.dialogData.data[1].value, // 资质名称
            type: this.dialogData.data[2].value, // 资质类型
            startServiceDate: this.dialogData.data[3].value, // 开始时间 年月日
            endServiceDate: this.dialogData.data[4].value.time, // 到期时间 年月日
            reminderDateOffset: this.qualificationData
              ? this.qualificationData.reminderDateOffset
              : "0", // 到期提醒时间
            annualReminder: this.dialogData.data[6].value || "", // 年审时间
            certificate: this.dialogData.data[7].value.value, // 证书路径
          };
          if (!requestData.name) {
            return this.$message.error("资质名称不能为空!");
          }
          if (!requestData.type) {
            this.$message.error("资质类型不能为空!");
            return;
          }
          if (!requestData.startServiceDate) {
            this.$message.error("资质开始日期不能为空!");
            return;
          }
          this.$request(
            "post",
            "/qualification/conserveQualificationInfo",
            requestData,
            (data) => {
              this.$message.success("资质添加成功!");
              this.dialogData.flag = false;
            },
            (error) => {
              this.$message.error(error);
            },
          );
          break;
        // 添加资质到小蓝本 行政许可
        case "sure_create_qualification_administrativeLicensing":
          requestData = {
            clientId: this.clientInfo.id,
            eid: this.enterpriseInfo.base.eid, // eid 必传
            entname: this.enterpriseInfo.base.entname, // 企业(机构)名称
            creditCode: this.enterpriseInfo.base.creditCode, // 统一社会信用代码 必传
            dataSourceState: 0, // 数据来源 0-手动添加；1-小蓝本同步 必传
            createUserId: this.baseInfo.userId, // 创建人ID
            createUserName: this.baseInfo.userName, // 创建人名称
          };
          this.dialogData.data.forEach((item) => {
            requestData[item.key] = item.value;
          });
          this.$request(
            "post",
            "/xlbEntAdmLic",
            requestData,
            (data) => {
              this.$message.success("添加成功!");
              this.getAdministrativeLicensing();
              this.dialogData.flag = false;
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          break;
        // 添加资质到小蓝本 资质证书
        case "sure_create_qualification_qualificationInformation":
          requestData = {
            clientId: this.clientInfo.id,
            eid: this.enterpriseInfo.base.eid, // eid 必传
            entname: this.enterpriseInfo.base.entname, // 企业(机构)名称
            creditCode: this.enterpriseInfo.base.creditCode, // 统一社会信用代码 必传
            dataSourceState: 0, // 数据来源 0-手动添加；1-小蓝本同步 必传
            createUserId: this.baseInfo.userId, // 创建人ID
            createUserName: this.baseInfo.userName, // 创建人名称
          };
          this.dialogData.data.forEach((item) => {
            requestData[item.key] = item.value;
          });
          this.$request(
            "post",
            "/xlbCertificate",
            requestData,
            (data) => {
              this.$message.success("添加成功!");
              this.getQualificationInformation();
              this.dialogData.flag = false;
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          break;
        // 添加资质到小蓝本 建筑资质
        case "sure_create_qualification_architectureQualification":
          requestData = {
            clientId: this.clientInfo.id,
            eid: this.enterpriseInfo.base.eid, // eid 必传
            entname: this.enterpriseInfo.base.entname, // 企业(机构)名称
            creditCode: this.enterpriseInfo.base.creditCode, // 统一社会信用代码 必传
            dataSourceState: 0, // 数据来源 0-手动添加；1-小蓝本同步 必传
            createUserId: this.baseInfo.userId, // 创建人ID
            createUserName: this.baseInfo.userName, // 创建人名称
          };
          this.dialogData.data.forEach((item) => {
            requestData[item.key] = item.value;
          });
          this.$request(
            "post",
            "/xlbBuildQualification",
            requestData,
            (data) => {
              this.$message.success("添加成功!");
              this.getArchitectureQualification();
              this.dialogData.flag = false;
            },
            (errorMessage) => {
              this.$message.error(errorMessage);
            },
          );
          break;
        case "cancel":
          this.dialogData.flag = false;
          break;
        default:
          break;
      }
    },
    pageChange(componentData) {
      switch (componentData.type) {
        case "companyList":
          this.getCompanyList(this.currentXidInfo, componentData.pageData);
          break;
        default:
          break;
      }
    },
    colseDialog() {
      this.dialogData.flag = false;
    },
    // 数字转为百分比
    NumberToPercentage(value) {
      const num = parseFloat(value);
      let percentage;
      if (num === 0) {
        percentage = "0%";
      } else if (num >= 0.1) {
        percentage = `${Math.round(num * 100)}%`;
      } else {
        percentage = `${(num * 100).toFixed(2)}%`;
      }
      return percentage;
    },
    changeTab() {
      switch (this.tabActive.tab2Active) {
        case "基本信息":
          this.callWithDelay(
            [
              this.getBusinessInformation,
              this.getShareholderInformation,
              this.getPrincipleMembers,
              this.getInvestmentAbroad,
              this.getBranchInformation,
              this.getBusinessChangeInformation,
            ],
            300,
          );
          break;
        case "公司发展":
          this.getProjectList();
          break;
        case "企业年报":
          this.entAnYears();
          break;
        case "资质资格":
          this.callWithDelay(
            [
              this.getAdministrativeLicensing,
              this.getQualificationInformation,
              this.getArchitectureQualification,
            ],
            300,
          );
          break;
        case "知识产权":
          this.callWithDelay(
            [
              this.getPatentInfo,
              this.getBrandInfo,
              this.getSoftwareCopyrightInfo,
              this.getWorkCopyrightInfo,
              this.getIPCInfo,
              this.getStandardInfo,
            ],
            300,
          );
          break;
        case "历史信息":
          this.getHistoryBusinessInformation();
          break;
        default:
          break;
      }
    },
    // 添加资质
    addQualification(data) {
      if (data.isHeader) {
        // 新增资质
        this.addQualificationToXiaoLanBen(data);
      } else {
        // 新增资质 到客户资质
        this.addQualificationToClient(data);
      }
    },
    // 删除资质
    deleteQualification(data) {
      let requestData = {};
      switch (data.type) {
        // 行政许可
        case "administrativeLicensing":
          this.$confirm("确定删除该资质吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              requestData = [data.row.id];
              this.$request(
                "delete",
                "/xlbEntAdmLic",
                requestData,
                (data) => {
                  this.$message.success("删除成功!");
                  this.getAdministrativeLicensing();
                },
                (errorMessage) => {
                  this.$message.error(errorMessage);
                },
              );
            })
            .catch(() => {});
          break;
        // 资质证书
        case "qualificationInformation":
          this.$confirm("确定删除该资质吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              requestData = [data.row.id];
              this.$request(
                "delete",
                "/xlbCertificate",
                requestData,
                (data) => {
                  this.$message.success("删除成功!");
                  this.getQualificationInformation();
                },
                (errorMessage) => {
                  this.$message.error(errorMessage);
                },
              );
            })
            .catch(() => {});
          break;
        // 建筑资质
        case "architectureQualification":
          this.$confirm("确定删除该资质吗？", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          })
            .then(() => {
              requestData = [data.row.id];
              this.$request(
                "delete",
                "/xlbBuildQualification",
                requestData,
                (data) => {
                  this.$message.success("删除成功!");
                  this.getArchitectureQualification();
                },
                (errorMessage) => {
                  this.$message.error(errorMessage);
                },
              );
            })
            .catch(() => {});
          break;
        default:
          break;
      }
    },
    addQualificationToXiaoLanBen(data) {
      this.dialogData.width = "550px";
      this.dialogData.title = "新建资质";
      this.dialogData.buttonArray = [];
      switch (data.type) {
        // 行政许可
        case "administrativeLicensing":
          this.dialogData.buttonArray.push({
            text: "确定",
            active: "sure_create_qualification_administrativeLicensing",
          });
          break;
        // 资质证书
        case "qualificationInformation":
          this.dialogData.buttonArray.push({
            text: "确定",
            active: "sure_create_qualification_qualificationInformation",
          });
          break;
        // 建筑资质
        case "architectureQualification":
          this.dialogData.buttonArray.push({
            text: "确定",
            active: "sure_create_qualification_architectureQualification",
          });
          break;
        default:
          break;
      }
      this.dialogData.buttonArray.push({
        text: "取消",
        active: "cancel",
      });
      this.dialogData.data = allClientData.getQualification(data.type);
      this.dialogData.flag = true;
    },
    addQualificationToClient(data) {
      let row = {};
      this.qualificationData = null;
      this.dialogData.width = "550px";
      this.dialogData.title = "新建资质";
      this.dialogData.buttonArray = [
        {
          text: "确定",
          active: "makesure_create_qualification",
        },
        {
          text: "取消",
          active: "cancel",
        },
      ];
      this.dialogData.id = "";
      switch (data.type) {
        // 行政许可
        case "administrativeLicensing":
          row = {
            number: data.row.licno, // 资质编号
            name: data.row.licname, // 资质名称
            startServiceDate: data.row.valform, // 资质开始时间
            endServiceDate: data.row.valto, // 资质到期时间
          };
          break;
        // 资质证书
        case "qualificationInformation":
          row = {
            number: data.row.licno, // 资质编号
            name: data.row.licname, // 资质名称
            startServiceDate: data.row.valform, // 资质开始时间
            endServiceDate: data.row.valto, // 资质到期时间
          };
          break;
        // 建筑资质
        case "architectureQualification":
          row = {
            number: data.row.registerNo, // 资质编号
            name: data.row.type, // 资质名称
            startServiceDate: data.row.validStart, // 资质开始时间
            endServiceDate: data.row.validEnd, // 资质到期时间
          };
          break;
        // 专利信息
        case "patentInfo":
          row = {
            number: data.row.outhorNum, // 资质编号
            name: data.row.patentName, // 资质名称
            startServiceDate: data.row.pubTime, // 资质开始时间
            // endServiceDate: data.row.validEnd, // 资质到期时间
          };
          break;
        // 商标信息
        case "brandInfo":
          row = {
            number: data.row.number, // 资质编号
            name: data.row.name, // 资质名称
          };
          break;
        // 软件著作权
        case "softwareCopyrightInfo":
          row = {
            number: data.row.crRegno, // 资质编号
            name: data.row.crName, // 资质名称
            startServiceDate: data.row.crRegdate, // 资质开始时间
          };
          break;
        // 作品著作权
        case "workCopyrightInfo":
          row = {
            number: data.row.wrRegistrationno, // 资质编号
            name: data.row.wrName, // 资质名称
            startServiceDate: data.row.wrPublicationdate, // 资质开始时间
          };
          break;
        // ICP备案
        case "IPCInfo":
          row = {
            number: data.row.icp, // 资质编号
            name: data.row.name, // 资质名称
          };
          break;
        // 标准信息
        case "standardInfo":
          row = {
            number: data.row.standardNo, // 资质编号
            name: data.row.name, // 资质名称
          };
          break;
        default:
          break;
      }
      this.dialogData.data = [
        {
          title: "资质编号",
          type: "input",
          value: row.number,
        },
        {
          title: "资质名称",
          type: "input",
          value: row.name,
          required: true,
        },
        {
          title: "资质类型",
          type: "select",
          options: this.qualificationTypeList,
          value: "",
          required: true,
        },
        {
          title: "资质开始时间",
          type: "time_date",
          value: row.startServiceDate,
          required: true,
        },
        {
          title: "资质到期时间",
          type: "ccc",
          value: {
            time: row.endServiceDate,
            noTime: row.endServiceDate ? false : true,
          },
          required: true,
        },
        {
          title: "到期提醒时间",
          type: "text",
          value: "",
        },
        {
          title: "年审时间",
          type: "text",
          value: "",
        },
        {
          title: "上传附件",
          type: "upload_file",
          value: {
            value: "", // 客户资质
            action: this.$fileBaseurl + "/uploadImageByMultipartFile",
            headers: {
              token: "95931b371eb64f4a9c862983ca8a5d15",
            },
            uploadParameter: {
              systemName: "finance",
              title: "客户资质",
            },
          },
          flag: false,
        },
      ];
      this.dialogData.flag = true;
    },
    // 添加老板资料
    addUser(data) {
      console.log("data.row", data.row);
      this.dialogData.width = "600px";
      this.dialogData.title = "添加老板资料";
      this.dialogData.buttonArray = [
        {
          text: "确认",
          active: "sure_add_user",
        },
        {
          text: "取消",
          active: "cancel",
        },
      ];
      this.dialogData.data = [
        {
          title: "老板姓名",
          type: "input",
          value: "",
          key: "name",
        },
        {
          title: "公司名称",
          type: "input",
          value: "",
          key: "companyName",
        },
      ];
      switch (data.type) {
        case "shareholderInformation":
          this.dialogData.data[0].value = data.row.inv;
          this.dialogData.data[1].value = "";
          break;
        case "principleMembers":
          this.dialogData.data[0].value = data.row.name;
          this.dialogData.data[1].value = "";
          break;
        case "investmentAbroad":
          this.dialogData.data[0].value = data.row.frname;
          this.dialogData.data[1].value = data.row.name;
          break;
        default:
          break;
      }
      this.dialogData.flag = true;
    },
    linkDialog(data) {
      console.log("data", data);
      switch (data.type) {
        case "patentInfo":
          // 专利信息
          this.dialogData.width = "1200px";
          this.dialogData.title = "专利详情";
          this.dialogData.buttonArray = [];
          this.dialogData.data = [
            {
              title: "",
              type: "enterprise-table-text",
              value: {
                list: [
                  {
                    title: "基础信息",
                    data: allClientData.companyInfoByTableText("基础信息"),
                  },
                  {
                    title: "申请人信息",
                    data: allClientData.companyInfoByTableText("申请人信息"),
                  },
                  {
                    title: "代理人信息",
                    data: allClientData.companyInfoByTableText("代理人信息"),
                  },
                  {
                    title: "法律状态",
                    data: allClientData.companyInfoByTableText("法律状态"),
                  },
                ],
              },
            },
          ];
          this.dialogData.data[0].value.list.forEach((item) => {
            item.data.forEach((it) => {
              it.value = data.row[it.key];
              if (it.key == "patentName") {
                it.value = this.enterpriseInfo.base.entname;
              }
            });
          });
          this.dialogData.flag = true;
          break;
        case "brandInfo":
          // 商标信息
          this.dialogData.width = "1200px";
          this.dialogData.title = "商标详情";
          this.dialogData.buttonArray = [];
          this.dialogData.data = [
            {
              title: "",
              type: "enterprise-table-text",
              value: {
                list: [
                  {
                    title: "基础信息",
                    data: allClientData.companyInfoByTableText("商标详情"),
                  },
                ],
              },
            },
          ];
          this.dialogData.data[0].value.list.forEach((item) => {
            item.data.forEach((it) => {
              it.value = data.row[it.key];
              if (it.label == "申请人名称") {
                it.value = this.enterpriseInfo.base.entname;
              }
            });
          });
          this.dialogData.flag = true;
          break;
        case "standardInfo":
          // 标准信息
          this.dialogData.width = "1200px";
          this.dialogData.title = "标准信息详情";
          this.dialogData.buttonArray = [];
          this.dialogData.data = [
            {
              title: "",
              type: "enterprise-table-text",
              value: {
                list: [
                  {
                    title: "",
                    data: allClientData.companyInfoByTableText("标准信息详情"),
                  },
                ],
              },
            },
          ];
          this.dialogData.data[0].value.list.forEach((item) => {
            item.data.forEach((it) => {
              it.value = data.row[it.key];
            });
          });
          this.dialogData.flag = true;
        default:
          break;
      }
    },
    changeFlag(val) {
      if (val) {
        this.dialogData.data[4].value.time = "";
      }
    },
    selectChange(value) {
      this.qualificationData = this.qualificationTypeList.find(
        (item) => item.id == value,
      );
      console.log("this.qualificationData", this.qualificationData);
      if (this.qualificationData) {
        if (this.qualificationData.expirationPeriod) {
          if (this.dialogData.data[3].value) {
            this.dialogData.data[4].value.time = this.calculateNewDate(
              this.dialogData.data[3].value,
              this.qualificationData.expirationPeriod,
            );
            this.dialogData.data[4].value.noTime = false;
          }
        } else {
          this.dialogData.data[4].value.time = "";
          this.dialogData.data[4].value.noTime = true;
        }

        if (this.qualificationData.reminderDateOffset) {
          this.dialogData.data[5].value = this.qualificationData
            .reminderDateOffset
            ? "前" + this.qualificationData.reminderDateOffset + "天"
            : "";
        } else {
          this.dialogData.data[5].value = "";
        }
        if (this.qualificationData.annualReminder) {
          this.dialogData.data[6].value = this.qualificationData.annualReminder;
        } else {
          this.dialogData.data[6].value = "";
        }
      }
    },
    datePickerChange(data) {
      if (data.item.title == "资质开始时间") {
        if (this.qualificationData && this.qualificationData.expirationPeriod) {
          this.dialogData.data[4].value.time = this.calculateNewDate(
            this.dialogData.data[3].value,
            this.qualificationData.expirationPeriod,
          );
          this.dialogData.data[4].value.noTime = false;
        } else {
          this.dialogData.data[4].value.time = "";
          this.dialogData.data[4].value.noTime = true;
        }
      }
      if (data.item.title == "资质到期时间") {
        this.dialogData.data[4].value.noTime = false;
      }
    },
    calculateNewDate(baseDate, yearOffset) {
      let date = new Date(baseDate);
      date.setFullYear(date.getFullYear() + yearOffset);
      return date.toISOString().split("T")[0]; // 返回 YYYY-MM-DD 格式
    },
    // 获取资质类型
    getQualificationType() {
      this.qualificationTypeList = [];
      this.$request(
        "get",
        "/qualificationType/list",
        {},
        (data) => {
          this.qualificationTypeList = data;
          this.qualificationTypeList.forEach((item) => {
            item.label = item.typeName;
            item.value = item.id;
          });
        },
        (errorMessage) => {
          this.$message.error(errorMessage);
        },
      );
    },
    /**
     * 附件上传成功
     */
    handleAvatarSuccess(data) {
      if (data.result.title == "客户资质") {
        this.$message({
          message: "客户资质上传成功!",
          type: "success",
          duration: 1000,
        });
        this.dialogData.data[7].value.value = data.result;
      }
    },
  },
  mounted() {
    this.baseInfo = JSON.parse(sessionStorage.getItem("userData"));
    this.getModelFeatureAuthority();
    this.getQualificationType();
    if (this.enterpriseInfo.base) {
      this.changeTab();
    }
  },
};
</script>

<style lang="less" scoped>
#enterprise-information {
  width: 100%;
  background-color: #fff;
  .enterprise-information-type {
    width: 100%;
    .enterprise-information-item {
      width: 100%;
      margin-top: 32px;
      scroll-margin-top: 180px;
      &:first-child {
        margin-top: 0;
      }

      .enterprise-information-item-title {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 8px;
        font-weight: 500;
        font-size: 16px;
        line-height: 28px;
        .enterprise-information-item-title-search {
          display: flex;
          .search-item {
            margin-left: 5px;
          }
        }
      }
      .enterprise-information-item-tag {
        display: flex;
        margin: 12px 0;
        .tag {
          font-size: 14px;
          color: #777e95;
          cursor: pointer;
          height: 28px;
          padding: 0 12px;
          line-height: 28px;
          cursor: pointer;
          border-radius: 14px;
        }
        .is-active {
          color: #327bf9;
          background: #eaf2ff;
        }
        .is-disabled {
          color: #c3c8da;
          cursor: not-allowed;
        }
      }
      .enterprise-information-item-value {
        width: 100%;
        .text {
          width: 100%;
          padding: 15px 23px;
          font-size: 14px;
          line-height: 24px;
          text-align: left;
          box-sizing: border-box;
          background: #f6f8fb
            url(https://51nbimg.u51.com/62c9ea111656463a90e8c968177a5d5d.png)
            right bottom / 102px 102px no-repeat;
        }
        .table-text {
          width: 100%;
          display: flex;
          flex-wrap: wrap;
          .table-text-item {
            width: 100%;
            height: 100%;
            display: flex;
            font-size: 14px;
            border: 1px solid #eff1f8;
            color: #111a34;

            .table-text-item-title {
              background-color: #f9fafc;
              width: 145px;
              min-width: 145px;
              text-align: right;
              padding: 13px 16px;
              box-sizing: border-box;
              color: #777e95;
              border-right: 1px solid #eff1f8;
            }
            .table-text-item-value {
              width: 80%;
              padding: 13px 16px;
              box-sizing: border-box;
              text-align: left;
              word-wrap: break-word;
              word-break: normal;
            }
          }
          .gather {
            .table-text-item-line {
              display: flex;
              &:last-child .table-text-item-value {
                border-bottom: 0;
              }
              .table-text-item-value {
                border-right: 1px solid #eff1f8;
                border-bottom: 1px solid #eff1f8;
                &:nth-child(even) {
                  border-right: 0;
                }
              }
            }
          }
        }
      }
    }
  }
  .activeColor {
    color: #327bf9 !important;
    cursor: pointer;
  }
}
</style>
